module.exports = __webpack_public_path__ + "static/img/product09-1.d93536a5.png";